import { Card } from '@/components/ui/card';
import { formatNumber } from '@/utils';

interface CreditDisplayProps {
  creditValue: number;
  onUpgradeClick: () => void;
}

export const CreditDisplay: React.FC<CreditDisplayProps> = ({ creditValue, onUpgradeClick }) => (
  <div className="flex-1 aspect-square bg-gradient-to-br from-[#383a3c] to-[#2b2e2f] rounded border border-[#46494c]">
    <Card className="w-full h-full overflow-hidden flex flex-col border-none rounded bg-transparent">
      <div
        className="from-[#ff5b27] to-[#993617] bg-gradient-to-b text-white text-xl font-medium flex-1 flex items-center justify-center shadow-inner"
        style={{ flexBasis: '50%' }}
      >
        <span>{formatNumber(creditValue)}</span>
        <span>&nbsp;LEFT</span>
      </div>
      <div className="from-[#2b2d2f] to-[#1b1d1e] flex-1 flex justify-center items-center shadow" style={{ flexBasis: '50%' }}>
        <div
          className="h-full w-full text-gray-400 text-2xl font-medium tracking-wide flex justify-center items-center font-pressura-mono cursor-pointer transition duration-300 ease-in-out hover:text-white"
          onClick={onUpgradeClick}
        >
          UPGRADE
        </div>
      </div>
    </Card>
  </div>
);
